
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ZAccordion',
  props: {
    defaultStyle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowMultiple: {
      type: Boolean,
      default: true
    },
    showBorders: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      accordionItems: []
    }
  }
})
